import "react-datepicker/dist/react-datepicker.css";

import React, { useEffect, useRef, useState } from "react";
import {
  formatDate,
  formatTime,
  getMonthByNumber,
} from "../../../utils/dateUtils";

import { CInput } from "@coreui/react";
import DatePicker from "react-datepicker";
import EmployeeCell from "./EmployeeCell";
import FormInput from "../form/inputs/FormInput";
import Select from "react-select";
import TimeCell from "./TimeCell";
import { enUS } from "date-fns/locale";
import { formatPhoneNumber } from "../../../utils/typeUtils";
import { inputTypes } from "../../../constants/input-types";
import { optionTypes } from "../../../constants/optionTypes";

const AKCell = ({
  option,
  type,
  typeStyle,
  item,
  itemKey,
  customInlineKeys,
  ignoreInlineKeys,
  onInlineEdit,
  inlineSelections,
  setInlineSelections,
  onCellClick,
  onInlineValidate,
  onInlineFormat,
  inlineCellValidation,
  validCells,
  lockedRows,
  lockedCells,
  emphasizedCells,
  handleShouldLockCell,
  handleShouldEmphasizeCell,
  forceRerender,
  setForceRerender,
  ...cellProps
}) => {
  const shouldCellBeLocked = lockedCells
    ? lockedCells.some(
        (lockedCell) =>
          lockedCell.index === item.index && lockedCell.key === itemKey,
      )
    : false;

  const shouldCellBeEmphasized = emphasizedCells
    ? emphasizedCells.some(
        (emphasizedCell) =>
          emphasizedCell.index === item.index && emphasizedCell.key === itemKey,
      )
    : false;

  const moneyRef = useRef();
  const [showMoneyInput, setShowMoneyInput] = useState();
  const [originalCellContent, setOriginalCellContent] = useState(item[itemKey]);
  const [cellContent, setCellContent] = useState(item[itemKey]);
  const [delimitedCellContent, setdelimitedCellContent] = useState(null);
  const [isValid, setIsValid] = useState(inlineCellValidation ? false : true);
  const [editingLocked, setEditingLocked] = useState(false);
  const [shouldLockCell, setShouldLockCell] = useState(shouldCellBeLocked);
  const [shouldEmphasizeCell, setShouldEmphasizeCell] = useState(
    shouldCellBeEmphasized,
  );

  useEffect(() => {
    if (forceRerender) {
      setCellContent(item[itemKey]);
      setForceRerender(false);
    }
  }, [forceRerender, setForceRerender, item, itemKey]);

  useEffect(() => {
    const shouldCellBeLocked = lockedCells
      ? lockedCells.some(
          (lockedCell) =>
            lockedCell.index === item.index && lockedCell.key === itemKey,
        )
      : false;

    setShouldLockCell(shouldCellBeLocked);
  }, [lockedCells, item.index, itemKey]);

  useEffect(() => {
    const shouldCellBeEmphasized = emphasizedCells
      ? emphasizedCells.some(
          (emphasizedCell) =>
            emphasizedCell.index === item.index &&
            emphasizedCell.key === itemKey,
        )
      : false;

    setShouldEmphasizeCell(shouldCellBeEmphasized);
  }, [emphasizedCells, item.index, itemKey]);

  useEffect(() => {
    if (handleShouldLockCell) {
      const shouldCellBeLocked = handleShouldLockCell(item, itemKey);

      setShouldLockCell(shouldCellBeLocked);
    }
  }, [handleShouldLockCell, item, itemKey]);

  useEffect(() => {
    if (handleShouldEmphasizeCell) {
      const shouldCellBeEmphasized = handleShouldEmphasizeCell(item, itemKey);

      setShouldEmphasizeCell(shouldCellBeEmphasized);
    }
  }, [handleShouldEmphasizeCell, item, itemKey]);

  useEffect(() => {
    if (option.delimited && cellContent.length > 1) {
      let delimitedCellContent = "";

      for (const value of cellContent) {
        delimitedCellContent = delimitedCellContent.concat(value);
        delimitedCellContent = delimitedCellContent.concat(", ");
      }

      setdelimitedCellContent(
        delimitedCellContent.substring(0, delimitedCellContent.length - 2),
      );
    } else {
      setdelimitedCellContent(null);
    }
  }, [cellContent, option.delimited]);

  useEffect(() => {
    if (lockedRows && lockedRows.length > 0) {
      const shouldLockRow = lockedRows.some((row) => row === item.index);

      setEditingLocked(shouldLockRow);
    } else {
      setEditingLocked(false);
    }
  }, [item.index, lockedRows]);

  useEffect(() => {
    setCellContent(item[itemKey]);
  }, [item, itemKey]);

  useEffect(() => {
    if (validCells) {
      const isValidCell = validCells.some(
        (validCell) =>
          validCell.index === item.index && validCell.key === itemKey,
      );

      setIsValid(isValidCell);
    }
  }, [validCells, item.index, itemKey]);

  useEffect(() => {
    if (showMoneyInput) {
      moneyRef.current.focus();
    }
  }, [showMoneyInput]);

  const handleMoneyInputClick = (event) => {
    event.preventDefault();
    setShowMoneyInput(true);
  };

  const handleInlineValidate = (value, key) => {
    const isValid = onInlineValidate(value, key);

    return isValid;
  };

  const handleInlineFormat = (event, key) => {
    const formattedValue = onInlineFormat(event, key);

    setCellContent(formattedValue);

    const validInput = handleInlineValidate(formattedValue, key);

    if (validInput) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }

    return { formattedValue, validInput };
  };

  const handleInlineEdit = (event, item, key) => {
    setShowMoneyInput(false);
    const { formattedValue, validInput } = handleInlineFormat(event, key);

    if (validInput) {
      onInlineEdit(formattedValue, item, key, event);
      setOriginalCellContent(formattedValue);
    } else {
      setCellContent(originalCellContent);
      setIsValid(true);
    }
  };

  const handleOnCellClick = (item, key) => {
    onCellClick(item, key);
  };

  const handleCleanCellContent = (content) => {
    if (itemKey === "workDetail" && content && content !== "") {
      content = content.replace("<br>", "");
      content = content.replace("<strong>", "");
      content = content.replace("</strong>", "");
    }

    if (option.precision) {
      content = +content.toFixed(option.precision);
    }

    return content;
  };

  switch (type) {
    case optionTypes.MONEY:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          onInlineEdit &&
          ignoreInlineKeys &&
          !shouldLockCell &&
          !ignoreInlineKeys.includes(itemKey) ? (
            <>
              <div
                hidden={showMoneyInput}
                style={{
                  fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
                }}
                onClick={handleMoneyInputClick}
              >{`$${(Math.round(+cellContent * 100) / 100).toFixed(2)}`}</div>
              <input
                ref={moneyRef}
                hidden={!showMoneyInput}
                style={{
                  fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
                }}
                className={
                  isValid
                    ? "ak-inline-input form-control"
                    : "ak-inline-invalid-input"
                }
                value={cellContent}
                onChange={(event) => handleInlineFormat(event, itemKey)}
                onBlur={(event) => handleInlineEdit(event, item, itemKey)}
              />
            </>
          ) : (
            <div
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
            >{`${
              +cellContent >= 0
                ? `$${(Math.round(+cellContent * 100) / 100).toFixed(2)}`
                : `($${(Math.round(Math.abs(+cellContent) * 100) / 100).toFixed(
                    2,
                  )})`
            }`}</div>
          )}
        </td>
      );
    case optionTypes.MONTH:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          onInlineEdit &&
          ignoreInlineKeys &&
          !ignoreInlineKeys.includes(itemKey) ? (
            <></> // TODO: Add inline editing logic for changing month
          ) : (
            <div
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
            >
              {getMonthByNumber(cellContent)}
            </div>
          )}
        </td>
      );
    case optionTypes.EMAIL_LIST:
      return (
        <td>
          <div
            className="ak-cell-container ak-cell-container-stacked"
            style={{ fontWeight: shouldEmphasizeCell ? "bolder" : "inherit" }}
          >
            {(cellContent ?? "")
              .split(",")
              .map((address) => address.trim())
              .filter((address) => address.length > 0)
              .map((address, i) => <div key={i}>{address}</div>)}
          </div>
        </td>
      );
    case optionTypes.EMPLOYEE:
      return (
        <EmployeeCell
          cellContent={cellContent}
          editingLocked={editingLocked}
          ignoreInlineKeys={ignoreInlineKeys}
          isValid={isValid}
          item={item}
          itemKey={itemKey}
          onInlineEdit={onInlineEdit}
          shouldEmphasizeCell={shouldEmphasizeCell}
          handleInlineEdit={handleInlineEdit}
          shouldLockCell={shouldLockCell}
          {...cellProps}
        />
      );
    case optionTypes.TIME:
      return (
        <TimeCell
          cellContent={cellContent}
          editingLocked={editingLocked}
          ignoreInlineKeys={ignoreInlineKeys}
          isValid={isValid}
          item={item}
          itemKey={itemKey}
          onInlineEdit={onInlineEdit}
          shouldEmphasizeCell={shouldEmphasizeCell}
          handleInlineEdit={handleInlineEdit}
          shouldLockCell={shouldLockCell}
          {...cellProps}
        />
      );
    case optionTypes.DATE:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          onInlineEdit &&
          ignoreInlineKeys &&
          !ignoreInlineKeys.includes(itemKey) ? (
            <DatePicker
              className={
                isValid ? "ak-inline-input" : "ak-inline-invalid-input"
              }
              selected={(cellContent && new Date(cellContent)) || null}
              onChange={(event) => handleInlineEdit(event, item, itemKey)}
              locale={enUS}
              customInput={<input className="ak-custom-input" />}
            />
          ) : (
            <div
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
            >
              {formatDate(cellContent)}
            </div>
          )}
        </td>
      );
    case optionTypes.PHONE:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          onInlineEdit &&
          ignoreInlineKeys &&
          !ignoreInlineKeys.includes(itemKey) ? (
            <CInput
              className={
                isValid ? "ak-inline-input" : "ak-inline-invalid-input"
              }
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
              value={formatPhoneNumber(cellContent)}
              onChange={(event) => handleInlineFormat(event, itemKey)}
              onBlur={(event) => handleInlineEdit(event, item, itemKey)}
            />
          ) : (
            <div
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
            >{`${cellContent ? formatPhoneNumber(cellContent) : ""}`}</div>
          )}
        </td>
      );
    case optionTypes.BOOLEAN:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          onInlineEdit &&
          !shouldLockCell &&
          ignoreInlineKeys &&
          !ignoreInlineKeys.includes(itemKey) ? (
            <label className="ak-checkbox-label">
              <input
                type="checkbox"
                value={cellContent}
                checked={cellContent}
                onChange={(event) => handleInlineEdit(event, item, itemKey)}
              />
              <span className="ak-checkbox-custom rectangular"></span>
            </label>
          ) : (
            <label className="ak-checkbox-label">
              <input
                className={"checkbox-input"}
                type="checkbox"
                value={cellContent}
                checked={cellContent}
                onChange={() => {
                  setCellContent((oldState) => !oldState);
                  setCellContent((oldState) => !oldState);
                }}
              />
              <span
                className="ak-checkbox-custom rectangular"
                style={{ backgroundColor: "#a9a9a9", borderColor: "#696969" }}
              ></span>
            </label>
          )}
        </td>
      );
    case optionTypes.BUTTON:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          onInlineEdit &&
          !shouldLockCell &&
          ignoreInlineKeys &&
          !ignoreInlineKeys.includes(itemKey) ? (
            <button
              className={
                isValid ? "ak-inline-button" : "ak-invalid-inline-button"
              }
              style={{
                fontWeight: "bolder",
              }}
              onClick={() => handleOnCellClick(item, itemKey)}
            >
              {typeStyle
                ? typeStyle === optionTypes.MONEY // TODO: Handle other typeStyles for button cells
                  ? `${
                      +cellContent >= 0
                        ? `$${(Math.round(+cellContent * 100) / 100).toFixed(
                            2,
                          )}`
                        : `($${(
                            Math.round(Math.abs(+cellContent) * 100) / 100
                          ).toFixed(2)})`
                    }`
                  : (cellContent ?? <div>&#8205;</div>)
                : (cellContent ?? <div>&#8205;</div>)}
            </button>
          ) : (
            <div
              className="ak-cell-container"
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
            >
              {delimitedCellContent
                ? handleCleanCellContent(delimitedCellContent)
                : handleCleanCellContent(cellContent)}
            </div>
          )}
        </td>
      );
    default:
      return (
        <td
          className={
            item.isPending === true
              ? "pending-item"
              : item.isActive === false
                ? "inactive-item"
                : item.status === "Cancelled"
                  ? "canceled-item"
                  : undefined
          }
        >
          {!editingLocked &&
          ignoreInlineKeys &&
          !shouldLockCell &&
          !ignoreInlineKeys.includes(itemKey) ? (
            onCellClick &&
            customInlineKeys &&
            customInlineKeys.includes(itemKey) ? (
              <Select
                className="ak-inline-select"
                value={{ value: cellContent, label: cellContent }}
                defaultValue={{ value: cellContent, label: cellContent }}
                onMenuOpen={() => handleOnCellClick(item, itemKey)}
                onBlur={setInlineSelections && (() => setInlineSelections([]))}
                onChange={
                  handleInlineEdit &&
                  ((event) => handleInlineEdit(event, item, itemKey))
                }
                options={
                  inlineSelections
                    ? inlineSelections.map((item) => {
                        if (item?.label) {
                          return { value: item.value, label: item.label };
                        }

                        return { value: item, label: item };
                      })
                    : []
                }
              />
            ) : (
              <CInput
                type="text"
                maxLength={option.maxLength ?? 300}
                className={
                  "ak-cell-container " +
                  (isValid ? "ak-inline-input" : "ak-inline-invalid-input")
                }
                style={{
                  fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
                }}
                value={cellContent != null ? cellContent : ""}
                onChange={(event) => handleInlineFormat(event, itemKey)}
                onBlur={(event) => handleInlineEdit(event, item, itemKey)}
              />
            )
          ) : (
            <div
              className="ak-cell-container"
              style={{
                fontWeight: shouldEmphasizeCell ? "bolder" : "inherit",
              }}
            >
              {delimitedCellContent
                ? handleCleanCellContent(delimitedCellContent)
                : handleCleanCellContent(cellContent)}
            </div>
          )}
        </td>
      );
  }
};

export default AKCell;
